import { connect } from 'react-redux';
import { breakpointSelector } from 'selectors';
import { MODAL_PATH } from 'reducers/modal';
import { MODAL } from 'constants';
import PasswordField from './PasswordField';

const mapStateToProps = (state) => {
  const modalQueue = state.getIn(MODAL_PATH.MODAL_QUEUE);
  const activeModalState = modalQueue.get(0);
  const isSignInModal = activeModalState?.get('modalKey') === MODAL.SIGN_IN_MODAL;

  return {
    breakpoint: breakpointSelector(state),
    isSignInModal,
  };
};

export default connect(mapStateToProps)(PasswordField);
